import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';
import InstagramIcon from '../images/instagram.png';
import LinkedInIcon from '../images/linkedin.png';

const Contact = () => {
    useDocTitle('DuoRoot Software | Send us a message');
  
    return (
        <>
            <div>
                <NavBar />
            </div>
            <div
                id="contact"
                className="flex justify-center items-center mt-24 w-full bg-white py-12 lg:py-24"
            ><div className="container mx-auto my-8 px-4 lg:px-20" data-aos="zoom-in">
                    <div className="w-full lg:w-3/6 px-8 py-6 mx-auto bg-blue-900 rounded-2xl"> 
                        <div className="flex flex-col text-white">
                            <div className="flex my-4 w-2/3 lg:w-3/4">
                                <div className="flex flex-col">
                                    <i className="fas fa-map-marker-alt pt-2 pr-2" />
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="text-2xl">Office Address</h2>
                                    <p className="text-gray-400">Baraj mh. 06140, Ankara, Türkiye</p>
                                </div>
                            </div>
                            <div className="mt-5">
                                <h2 className="text-2xl">Send an E-mail</h2>
                                <p className="text-gray-400">softwareduoroot@gmail.com</p>
                            </div>
                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <a
                                    href="https://www.instagram.com/duorootsoftware/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="rounded-full flex justify-center bg-transparent h-8 text-blue-900 w-8 mx-1 text-center p-0" 
                                    aria-label="Instagram"
                                >
                                    <img src={InstagramIcon} alt="Instagram" className="w-8 h-8" />
                                </a>
                                <a
                                    href="https://www.linkedin.com/duoroot-software?_l=en_US"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="rounded-full flex justify-center bg-transparent h-8 text-blue-900 w-8 mx-1 text-center p-0"
                                    aria-label="LinkedIn"
                                >
                                    <img src={LinkedInIcon} alt="LinkedIn" className="w-8 h-8" />
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Contact;
